import { fmtDate } from "@/lib/dates";
import { Trash2, History } from "lucide-react";
import { Modal } from "@/components/Modal";
import { Button } from "@/components/Button";
import { useAuth } from "@/context/AuthContext";

const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" }) : "");

function ContribRow({ c, mine, onRemove }) {
  return (
    <div className="flex items-center gap-3 py-2.5 border-b border-white/5 last:border-0" data-testid="history-contribution">
      <div className="flex-1 min-w-0">
        <p className="text-sm text-slate-200 truncate">{c.user_name}</p>
        <p className="text-xs text-slate-500">{fmtDate(c.at)} · {fmtTime(c.at)}</p>
      </div>
      <span className="text-sm font-semibold text-sky-300 shrink-0">+${Number(c.amount).toFixed(2)}</span>
      {mine && onRemove && (
        <button onClick={() => onRemove(c)} className="p-1.5 text-slate-500 hover:text-red-400 shrink-0" title="Remove my contribution" data-testid="remove-contribution-btn">
          <Trash2 size={14} />
        </button>
      )}
    </div>
  );
}

function List({ items, meId, onRemove }) {
  const sorted = [...(items || [])].sort((a, b) => (b.at || "").localeCompare(a.at || ""));
  if (!sorted.length) return <p className="text-sm text-slate-500 py-2">No contributions yet.</p>;
  return <div>{sorted.map((c) => <ContribRow key={c.id} c={c} mine={c.user_id === meId} onRemove={onRemove} />)}</div>;
}

export function ContributionHistory({ open, onClose, title, contributions, periods = [], onRemove }) {
  const { user } = useAuth();
  return (
    <Modal open={open} onClose={onClose} title={title} testId="contribution-history-modal"
      footer={<Button variant="secondary" full onClick={onClose}>Close</Button>}>
      <p className="text-xs font-semibold uppercase tracking-wider text-sky-400/80 mb-1">{periods.length ? "Current period" : "Contributions"}</p>
      <List items={contributions} meId={user?.id} onRemove={onRemove} />
      {periods.map((p, i) => (
        <div key={i} className="mt-5" data-testid="history-period">
          <div className="flex items-center justify-between mb-1">
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 flex items-center gap-1.5"><History size={12} /> Due {fmtDate(p.due_date)}</p>
            <span className="text-xs text-slate-500">${Number(p.paid_amount || 0).toFixed(2)} of ${Number(p.amount || 0).toFixed(2)}</span>
          </div>
          <List items={p.contributions} meId={null} />
        </div>
      ))}
    </Modal>
  );
}
